import type { ChangeEvent, FC } from "react";

import classNames from "classnames";

import { SupportingText } from "@jti/core-components/components/SupportingText";
import type { ICurrencyEnum } from "@jti/magento";
import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";
import { useTranslations } from "@jti/ui";

import { CheckOutLoyaltyPointsDiscountsList } from "../CheckoutLoyaltyPointsDiscountsList";

export interface Voucher {
  campaign_id: string;
  points: number;
  price: number;
}

export type CheckOutLoyaltyPointsDiscountsProps = {
  currency: ICurrencyEnum;
  vouchers: GetEligibleCampaignsResponseType[];
  isQueryCampaign: boolean;
  isLoyaltyError: boolean;
  loyaltyCampaignId: string;
  handleCampaignChange: (arg0: ChangeEvent<HTMLInputElement>) => void;
};

export const CheckoutLoyaltyPointsDiscounts: FC<CheckOutLoyaltyPointsDiscountsProps> = ({
  currency,
  vouchers,
  isQueryCampaign,
  loyaltyCampaignId,
  isLoyaltyError,
  handleCampaignChange,
}) => {
  const { __ } = useTranslations();

  return (
    <div
      className={classNames({
        "checkout-loyalty-points__discounts-container": true,
        "checkout-loyalty-points__discounts-container--inProgress": isQueryCampaign,
      })}
    >
      <CheckOutLoyaltyPointsDiscountsList
        currency={currency}
        vouchers={vouchers}
        loyaltyCampaignId={loyaltyCampaignId}
        isLoyaltyError={isLoyaltyError}
        handleCampaignChange={handleCampaignChange}
      />

      {isLoyaltyError ? (
        <SupportingText data-testid="redeemError" variant="error">
          {__("loyalty.checkout.discountError")}
        </SupportingText>
      ) : null}
    </div>
  );
};
